import { ref } from 'vue';

export const useTableMethods = () => {
    const tableRef = ref();

    const setSort = (field, order, refresh) => {
        !!tableRef.value && tableRef.value.setSort({ field, order }, refresh); // 最后一个参数为true时更新表本数据
    };

    // 根据行数据获取数据id
    const getRowId = (row) => {
        if (tableRef.value) {
            return tableRef.value.getRowid(row);
        }
        return '';
    };

    // getRowById 根据id获取行数据
    const getRowById = (id) => {
        if (tableRef.value) {
            return tableRef.value.getRowById(id);
        }
        return null;
    };

    const openExport = () => {
        !!tableRef.value && tableRef.value.openExport();
    };

    const openPrint = () => {
        !!tableRef.value && tableRef.value.openPrint();
    };

    const openCustom = () => {
        !!tableRef.value && tableRef.value.openCustom();
    };

    // getTable 获取表格实例
    const getTable = () => {
        return tableRef.value;
    };

    // 列type=radio时获取选择的行数据
    const getRadioRow = (isFull = true) => {
        if (!tableRef.value) return null;
        return tableRef.value.getRadioRecord(isFull);
    };

    // 列type=checkbox时，获取钩选的数据行列表
    const getCheckboxRows = (isFull = true) => {
        if (!tableRef.value) return [];
        return tableRef.value.getCheckboxRecords(isFull);
    };

    // 获取序列的列列表信息, onlyField=true时只返回字段名和排序方式
    const getSortColumns = (onlyField = true) => {
        let columns = [];
        if (tableRef.value) {
            columns = tableRef.value.getSortColumns();
            if (onlyField) {
                return columns.map(item => ({ field: item.field, order: item.order }));
            }
            return columns;
        }
        return [];
    };

    const loadColumn = (columns) => {
        !!tableRef.value && tableRef.value.loadColumn(columns);
    };
    const reloadColumn = (columns) => {
        !!tableRef.value && tableRef.value.reloadColumn(columns);
    };
    const refreshColumn = () => {
        !!tableRef.value && tableRef.value.refreshColumn();
    };
    const getColumns = () => {
        if (tableRef.value) {
            return tableRef.value.getColumns();
        }
        return [];
    };

    const getTableData = () => {
        if (tableRef.value) {
            return tableRef.value.getTableData();
        }
        return { fullData: [], visibleData: [], tableData: [], footerData: [] };
    };

    const getFullData = () => {
        if (tableRef.value) {
            return tableRef.value.getFullData();
        }
        return [];
    };

    const getRowData = (rowIndex) => {
        if (tableRef.value) {
            return tableRef.value.getData(rowIndex) || {};
        }
        return {};
    };

    const getCurrentRow = (isFull = true) => {
        if (tableRef.value) {
            return tableRef.value.getCurrentRecord(isFull);
        }
        return {};
    };

    const getSelectRow = () => {
        if (tableRef.value) {
            const { row } = tableRef.value.getSelectedCell();
            return row;
        }
        return {};
    };

    const setCurrentRow = (row) => {
        !!tableRef.value && tableRef.value.setCurrentRow(row);
    };

    const setRadioRow = (row) => {
        !!tableRef.value && tableRef.value.setRadioRow(row);
    };

    const setRadioRowKey = (key) => {
        !!tableRef.value && tableRef.value.setRadioRowKey(key);
    };

    const setCheckboxRow = (rows, checked) => {
        !!tableRef.value && tableRef.value.setCheckboxRow(rows, checked);
    };

    const setCheckboxRowKey = (keys, checked) => {
        !!tableRef.value && tableRef.value.setCheckboxRowKey(keys, checked);
    };

    const setAllCheckboxRow = (checked) => {
        !!tableRef.value && tableRef.value.setAllCheckboxRow(checked);
    };

    const toggleCheckboxRow = (row) => {
        !!tableRef.value && tableRef.value.toggleCheckboxRow(row);
    };

    const toggleAllCheckboxRow = () => {
        !!tableRef.value && tableRef.value.toggleAllCheckboxRow();
    };

    const clearCurrentRow = () => {
        !!tableRef.value && tableRef.value.clearCurrentRow();
    };

    const clearRadioRow = () => {
        !!tableRef.value && tableRef.value.clearRadioRow();
    };

    const clearRadioReserve = () => {
        !!tableRef.value && tableRef.value.clearRadioReserve();
    };

    const clearCheckboxRow = () => {
        !!tableRef.value && tableRef.value.clearCheckboxRow();
    };

    const clearCheckboxReserve = () => {
        !!tableRef.value && tableRef.value.clearCheckboxReserve();
    };

    const updateFooter = () => {
        !!tableRef.value && tableRef.value.updateFooter();
    };

    return {
        tableRef,
        setSort,
        getRowById,
        getRowId,
        openExport,
        openPrint,
        openCustom,
        getTable,
        getRadioRow,
        getCheckboxRows,
        getSortColumns,
        loadColumn,
        reloadColumn,
        refreshColumn,
        getColumns,
        getTableData,
        getFullData,
        getRowData,
        getCurrentRow,
        getSelectRow,
        setCurrentRow,
        setRadioRow,
        setRadioRowKey,
        setCheckboxRow,
        setCheckboxRowKey,
        setAllCheckboxRow,
        toggleCheckboxRow,
        toggleAllCheckboxRow,
        clearCurrentRow,
        clearRadioRow,
        clearRadioReserve,
        clearCheckboxRow,
        clearCheckboxReserve,
        updateFooter,
    };
};
